import React, { ReactNode } from 'react';
import { Typography } from 'antd';

import { CLIENT_CONST } from '../constants';
import Disclaimer from '../components/Disclaimer';
import logoSvg from '../images/logo.svg';

const { Title } = Typography;

interface Props {
  children?: ReactNode | ReactNode[];
  title: string;
}

export function PublicPageLayout(props: Props) {
  return (
    <div className="public-page">
      <div className="public-page__splash-container">
        <img
          src="/assets/img/splash.jpg"
          data-src="/assets/img/splash.jpg"
          data-src-retina="/assets/img/splash.jpg"
          alt=""
        />
      </div>

      <img
        src={logoSvg}
        alt=""
        className="public-page__icon"
      />

      <div className="public-page__right-content">
        <Title
          level={1}
          className="public-page__title"
        >
          {props.title}
        </Title>

        <>{props.children}</>

        <Disclaimer className="public-page__disclaimer"/>
      </div>
    </div>
  );
}
